import { Observable } from 'rxjs';

import { UserModuleAnswer } from 'user/user-module-answer';

import { ObserveUserAnswersByModulesIdQuery } from '../../../query/module/answer/observe-user-answers-by-modules-id.query';

export abstract class UserModuleAnswerRepositoryPort {
	public abstract observeUserAnswersByModulesId(
		query: ObserveUserAnswersByModulesIdQuery
	): Observable<UserModuleAnswer[]>;

	public abstract saveUserAnswers(
		userAnswers1: UserModuleAnswer[]
	): Promise<void>;

	public abstract observeUserAnswersByQuestionsId(
		userId: string,
		questionsId: string[]
	): Observable<UserModuleAnswer[]>;

	public abstract removeUserAnswersByIds(answersId: string[]): Promise<void>;
}
